import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { ColumnCell } from 'modules/_shared/Table/types/ColumnCell';
import TableHeader from 'modules/_shared/Table/components/TableHeader';
import ExpandButton from '../ExpandButton';
import { useHistoryMovementsView } from '../../context/HistoryMovementsViewContext';

const ReclassificationTableHeader: FC = () => {
  const { t } = useTranslate();

  const { data, actions } = useHistoryMovementsView();

  const columns = [
    { key: 'from', content: t('From'), textPosition: 'right' },
    { key: 'to', content: t('To'), textPosition: 'right' },
    { key: 'class', content: t('Class'), textPosition: 'center' },
    { key: 'newFrom', content: t('NewFrom'), textPosition: 'right' },
    { key: 'newTo', content: t('NewTo'), textPosition: 'right' },
    { key: 'newClass', content: t('NewClass'), textPosition: 'center' },
    {
      key: 'action',
      content: (
        <ExpandButton
          onClick={actions.handleChangeExpandView}
          expandDirection={data.expandDirection}
        />
      ),
      textPosition: 'right',
    },
  ] as ColumnCell[];

  return <TableHeader columns={columns} />;
};

export default ReclassificationTableHeader;
